<template>
  <div class="app-container">
    <CrudTable entity="TransportRoute" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';

export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'countryCode', label: 'transportRoute.countryCode' },
        { field: 'postalCodeFrom', label: 'transportRoute.postalCodeFrom' },
        { field: 'postalCodeTo', label: 'transportRoute.postalCodeTo' },
        { field: 'code', label: 'transportRoute.code' }
      ]
    };
  },
  methods: {
    generateSummary({ countryCode, postalCodeFrom, postalCodeTo, code }) {
      return `${countryCode} ${postalCodeFrom} ${postalCodeTo} ${code}`;
    }
  }
};
</script>

<style scoped></style>
